import { jsx } from "react/jsx-runtime";
import { useEditor, usePassThroughWheelEvents } from "@tldraw/editor";
import classNames from "classnames";
import { memo, useCallback, useEffect, useRef } from "react";
import { useRelevantStyles } from "../../hooks/useRelevantStyles.mjs";
import { DefaultStylePanelContent } from "./DefaultStylePanelContent.mjs";
const DefaultStylePanel = memo(function DefaultStylePanel2({
  isMobile,
  children
}) {
  const editor = useEditor();
  const ref = useRef(null);
  usePassThroughWheelEvents(ref);
  const styles = useRelevantStyles();
  const handlePointerOut = useCallback(() => {
    if (!isMobile) {
      editor.updateInstanceState({ isChangingStyle: false });
    }
  }, [editor, isMobile]);
  const content = children ?? /* @__PURE__ */ jsx(DefaultStylePanelContent, { styles });
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape" && ref.current?.contains(document.activeElement)) {
        event.stopPropagation();
        editor.getContainer().focus();
      }
    }
    const stylePanelContainerEl = ref.current;
    stylePanelContainerEl?.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      stylePanelContainerEl?.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [editor]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className: classNames("tlui-style-panel", { "tlui-style-panel__wrapper": !isMobile }),
      "data-ismobile": isMobile,
      onPointerLeave: handlePointerOut,
      children: content
    }
  );
});
export {
  DefaultStylePanel
};
//# sourceMappingURL=DefaultStylePanel.mjs.map
